export const de_DE = {
    localeIdentifier: 'de-DE',
    search: {
        clear: 'Löschen',
    },
    slider: {
        selectedRange: ({ start, end }) => `${start} bis ${end}`,
        startAriaLabel: 'Start',
        endAriaLabel: 'Ende',
    },
    datePicker: {
        format: 'dd.MM.yyyy',
        pattern: '[0-9]{1,2}.[0-9]{1,2}.[0-9]{1,4}',
        weekStartsOn: 1,
        dateLocale: 'de-DE',
        previousMonthLabel: 'Vorheriger Monat',
        nextMonthLabel: 'Nächster Monat',
        calendarOverlayLabel: 'Wählen Sie ein Datum aus',
        openCalendarLabel: 'Kalender öffnen',
        cancelLabel: 'Schließen',
        confirmLabel: 'Übernehmen',
        monthSelectorLabel: 'Monat',
        changeLabel: 'Ändern',
        yearSelectorLabel: 'Jahr',
    },
    formHelperText: {
        errorIconTitle: 'Fehler',
    },
    formLabel: { optional: '(optional)' },
    pagination: {
        ellipsis: '…',
        previous: 'Vorherige',
        next: 'Nächste',
        ariaLabel: 'Paginierung',
        ariaGoToPrevious: 'Vorherige Seite',
        ariaGoToNext: 'Nächste Seite',
        ariaCurrentPage: (page) => `Seite ${page}, aktuelle Seite`,
        ariaGoToPage: (page) => `Seite ${page}`,
    },
    popover: {
        closeLabel: 'Schließen',
    },
    tag: {
        removeLabel: 'Entfernen',
    },
};
//# sourceMappingURL=de_DE.mjs.mjs.map